document.addEventListener("DOMContentLoaded", function () {
  const selectMarca = document.getElementById("selectMarca");
  const selectModelo = document.getElementById("selectModelo");
  const formFiltros = document.getElementById("filtros-anuncios");

  // Máscara para campos de preço
  const camposDinheiro = document.querySelectorAll(".mascara-dinheiro");
  if (camposDinheiro.length > 0) {
    camposDinheiro.forEach(function (campo) {
      campo.addEventListener("input", function (e) {
        // Remove tudo que não é número
        let valor = e.target.value.replace(/\D/g, "");

        // Converte para decimal (divide por 100)
        valor = (valor / 100).toFixed(2);

        // Formata com R$ e separadores
        valor =
          "R$ " + valor.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        e.target.value = valor;
      });
    });
  }

  // Quando uma marca for selecionada
  selectMarca.addEventListener("change", function () {
    const urlMarca = this.value;

    if (urlMarca) {
      window.location.href = urlMarca;
    }
  });

  // Para garantir que o botão de envio do formulário funcione corretamente
  formFiltros.addEventListener("submit", function (e) {
    e.preventDefault();

    // Obter o URL base atual (mantém a categoria/marca selecionada)
    let url = window.location.pathname;
    const params = new URLSearchParams();

    // Pegar valores dos filtros
    const ordenacao = document.getElementById("ordenacao").value;
    if (ordenacao) params.append("ordenacao", ordenacao);
    const anoInicio = document.getElementById("anoInicio").value;
    const anoFim = document.getElementById("anoFim").value;
    //const selectTipo = document.getElementById("selectTipo").value;
    const precoInicio = document
      .getElementById("precoInicio")
      .value.replace(/\D/g, "");
    const precoFim = document
      .getElementById("precoFim")
      .value.replace(/\D/g, "");

    // Adicionar parâmetros se tiverem valor
    if (anoInicio) params.append("anoInicio", anoInicio);
    if (anoFim) params.append("anoFim", anoFim);
    //if (selectTipo) params.append("selectTipo", selectTipo);
    if (precoInicio)
      params.append("precoInicio", (precoInicio / 100).toFixed(2));
    if (precoFim) params.append("precoFim", (precoFim / 100).toFixed(2));

    // Se o select de modelo estiver habilitado e com valor, adicione-o
    if (selectModelo && !selectModelo.disabled && selectModelo.value) {
      params.append("modelo", selectModelo.value);
    }

    // Montar URL final
    if (params.toString()) {
      url += "?" + params.toString();
    }

    // Redirecionar
    window.location.href = url;
  });

  // Validar intervalo de anos (ano inicial não pode ser maior que o final)
  const anoInicio = document.getElementById("anoInicio");
  const anoFim = document.getElementById("anoFim");

  anoInicio.addEventListener("change", function () {
    if (anoFim.value && parseInt(this.value) > parseInt(anoFim.value)) {
      alert("O ano inicial não pode ser maior que o ano final");
      this.value = "";
    }
  });

  anoFim.addEventListener("change", function () {
    if (anoInicio.value && parseInt(this.value) < parseInt(anoInicio.value)) {
      alert("O ano final não pode ser menor que o ano inicial");
      this.value = "";
    }
  });
});
